import {DisposalSet, select} from '@neptune/cx/utils';
import { registerFragment } from '@neptune/cx/registry';

import './styles.scss';

const gc = new DisposalSet();

registerFragment('chroa-betty-bot-widget', (fragmentEl, config, meta) => {
    // *Toggle Logic
    const fabBtn = fragmentEl.querySelector("#bettyFab") as HTMLButtonElement;
    const fabLogo = fragmentEl.querySelector("#bettyLogo") as HTMLButtonElement;
    const chatPanel = fragmentEl.querySelector("#bettyChat") as HTMLDivElement;

    fabBtn.addEventListener("click", (e: MouseEvent) => {
        e.preventDefault();

        fabBtn.classList.toggle("chroa-betty-bot-widget__fab--active")
        fabLogo.classList.toggle("chroa-betty-bot-widget__fab__logo--active")
        chatPanel.classList.toggle("chroa-betty-bot-widget__chat--active")
    })

    // *Submission Logic
    const form = fragmentEl.querySelector("#bettyForm") as HTMLFormElement;
    const formInput = fragmentEl.querySelector('#widget-input') as HTMLInputElement;

    function escapeHtml(unsafe: string) {
        return unsafe
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;')
    }


    form.addEventListener("submit", (e: Event) => {
        e.preventDefault();

        const userInput = escapeHtml(formInput.value.trim());

        sessionStorage.setItem("bettyBotQuery", userInput);
        form.reset();

        // this is the agreed upon endpoint for this page in all instances!
        window.location.href = "/sage";
    });
});

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => gc.disposeAll());
}
